<template>
	<div>
		<v-dialog v-model="visible" width="1080" persistent>
			<v-card>
				<v-card-title>
					<v-icon style="margin-right: 10px">{{ icon }}</v-icon
					>{{ title }}
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="formValid">
						<v-row align="start" style="margin-top: 10px" class="pa-0 ma-0">
							<v-col class="pa-0 ma-0">
								<v-container>
									<v-row align="start" class="item-title">
										<v-col class="item-content">
											<v-text-field v-model="item.uid" label="사용자 식별 값" type="text" filled disabled />
										</v-col>
										<v-col class="item-content">
											<v-text-field v-model="item.signUpMethodTypeName" label="가입유형" type="text" filled disabled />
										</v-col>
										<v-col class="item-content">
											<v-text-field
												label="생성일"
												type="text"
												filled
												readonly
												name="user-createAt"
												:value="!$utils.isEmpty(item.createAt) ? $moment(item.createAt.toDate()).format('YYYY/MM/DD HH:mm:ss') : ''"
											/>
										</v-col>
									</v-row>
									<v-row align="start" class="item-title">
										<v-col class="item-content">
											<v-text-field v-model="item.email" label="이메일" type="text" filled readonly />
										</v-col>
										<v-col class="item-content">
											<v-text-field v-model="item.name" label="이름" type="text" filled readonly />
										</v-col>
										<v-col class="item-content">
											<v-text-field v-model="item.nickname" label="닉네임" type="text" filled readonly />
										</v-col>
									</v-row>
									<v-row align="start" class="item-title">
										<v-col class="item-content">
											<v-text-field v-model="item.phoneNum" label="연락처" type="text" filled readonly />
										</v-col>
										<v-col class="item-content">
											<v-text-field v-model="item.storeName" label="근무지" type="text" filled readonly />
										</v-col>
										<v-col class="item-content">
											<v-text-field label="근무상태" type="text" filled readonly name="user-createAt" :value="item.designerIsWork ? 'On' : 'Off'" />
										</v-col>
									</v-row>
									<v-row align="start" class="item-title">
										<v-col class="item-content">
											<v-select
												v-model="item.designerAccountBrandType"
												:items="designerAccountBrandTypes"
												item-value="code"
												item-text="text"
												label="은행유형"
												outlined
												@change="updateTypeName(item.designerAccountBrandType, 'designerAccountBrandTypeName', designerAccountBrandTypes)"
											></v-select>
										</v-col>
										<v-col class="item-content">
											<v-text-field v-model="item.designerAccountNumber" label="계좌번호" type="text" />
										</v-col>
										<v-col class="item-content">
											<v-select
												v-model="item.designerAuthStatusType"
												:items="designerAuthStatusTypes"
												item-value="code"
												item-text="text"
												label="인증상태"
												outlined
												@change="updateTypeName(item.designerAuthStatusType, 'designerAuthStatusTypeName', designerAuthStatusTypes)"
											></v-select>
										</v-col>
									</v-row>
									<v-row class="item-content">
										<v-col class="item-title">
											<v-icon style="margin-right: 10px">{{ 'mdi-image' }} </v-icon>사진
										</v-col>
										<v-col class="item-title">
											<v-icon style="margin-right: 10px">{{ 'mdi-image' }} </v-icon>자격증 사진
										</v-col>
									</v-row>
									<v-row class="item-content">
										<v-col class="item-content">
											<v-img v-if="$utils.isEmpty(item.imageUrl) == false" :src="item.imageUrl" width="300" contain />
											<div v-if="$utils.isEmpty(item.imageUrl)" style="height: 360px;">없음</div>
										</v-col>
										<v-col class="item-content">
											<v-img v-if="$utils.isEmpty(item.designerLicenseImageUrl) == false" :src="item.designerLicenseImageUrl" width="300" contain />
											<div v-if="$utils.isEmpty(item.designerLicenseImageUrl)" style="height: 360px;">없음</div>
										</v-col>
									</v-row>

									<v-row align="start" class="item-title">
										<v-col class="item-title">
											<v-icon style="margin-right: 10px">{{ 'mdi-bank' }} </v-icon> 정산내역
										</v-col>
									</v-row>
									<v-row align="start" class="item-content">
										<v-col class="item-content">
											<div v-if="$utils.isEmpty(item.chargeHistory) == false">
												<div v-if="item.chargeHistory.length > 0">
													<div v-for="(chargeHistory, i) in item.chargeHistory" :key="i">
														{{ chargeHistory }}
													</div>
												</div>
												<div v-if="item.chargeHistory.length == 0">없음</div>
											</div>
											<div v-if="$utils.isEmpty(item.chargeHistory) == true">없음</div>
										</v-col>
									</v-row>
									<!-- <v-row>
										<v-col>
											<v-btn rounded :color="$theme.primary" dark elevation="0" @click="onClickReportButton">
												<v-icon style="margin-right:4px">mdi-cash-multiple</v-icon>월별 매출 내역
											</v-btn>
										</v-col>
									</v-row> -->
								</v-container>
							</v-col>
						</v-row>

						<v-container>
							<v-row align="start" class="item-title">
								<v-col class="item-title"> <v-icon style="margin-right: 10px">mdi-format-list-bulleted</v-icon>메뉴 목록 </v-col>
							</v-row>
							<v-row>
								<v-col>
									<DesignerMenuList :headers="headers" :items="menus"> </DesignerMenuList>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions class="d-flex justify-right">
					<v-spacer></v-spacer>
					<v-btn v-if="okButton" rounded :color="$theme.primary" dark elevation="0" @click="onOk">{{ okButtonText }}</v-btn>
					<v-btn rounded :color="$theme.lightGrey" dark elevation="0" @click="$emit('onCancel')">{{ cancelButtonText }}</v-btn>
					<v-btn v-if="deleteButton" rounded :color="$theme.red" dark elevation="0" @click="$emit('onDelete')">{{ deleteButtonText }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 처리중입니다 다이얼로그 -->
		<message-dialog :show="workingStateDialog" message="처리중입니다. 잠시만 기다려주세요." :okButton="false" :cancelButton="false" />

		<!-- <select-reservation-dialog :item="item" :show="selectReservationDialog" @onCancel="selectReservationDialog = false"> </select-reservation-dialog> -->
	</div>
</template>

<script>
	import { designerAuthStatusTypes, designerAccountBrandTypes } from '@/js/types'; // 절대 경로 사용
	export default {
		name: 'DesignerEditDialog',
		props: {
			show: {
				default: false,
			},
			icon: {
				default: '',
			},
			title: {
				default: '',
			},
			okButton: {
				default: true,
			},
			deleteButton: {
				default: false,
			},
			okButtonText: {
				default: 'Confirm',
			},
			cancelButtonText: {
				default: 'Cancel',
			},
			deleteButtonText: {
				default: 'Delete',
			},
			item: {
				default: {},
			},
		},
		data: () => ({
			visible: false,
			items: [],
			formValid: false,
			workingStateDialog: false,
			reportButton: false,
			menus: [],
			headers: [
				{ text: '생성일', align: 'start', sortable: true, value: 'createAt' },
				{ text: '이름', align: 'start', sortable: true, value: 'title' },
				{ text: '헤어 성별', align: 'start', sortable: true, value: 'hairGenderType' },
				{ text: '가격', align: 'start', sortable: true, value: 'price' },
			],
			selectReservationDialog: false,
			designerAccountBrandTypes,
			designerAuthStatusTypes,
		}),
		watch: {
			async show() {
				this.visible = this.show;
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.resetValidation();
					}
				});

				if (this.$utils.isEmpty(this.item.id) == false) {
					this.menus = await this.$database.loadMenus(this.item.id);
				}
			},
			async item() {},
		},
		mounted() {
			document.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			updateTypeName(selectedValue, fieldName, typesArray) {
				const selectedItem = typesArray.find(item => item.code === selectedValue);

				if (selectedItem) {
					this.item[fieldName] = selectedItem.text;
				}
			},
			handleKeydown(event) {
				if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
					this.$emit('onCancel');
				}
			},
			onOk() {
				this.$refs.form.validate();
				if (this.formValid) {
					this.$emit('onOk', this.item);
				}
			},
			onClickReportButton() {
				this.selectReservationDialog = true;
			},
		},
	};
</script>
